module.exports = __webpack_public_path__ + "img/zhuan2.2d9e64b9.png";